import React from 'react';
import { Tabs, Card } from 'antd';
import { useSelector } from 'react-redux';

import Layout from '../Layout/index';
import ErrorBoundary from '../../components/Utils/ErrorBoundary';

import CategoryManager from './CategoryManager';
import './styles.css';
import EmployeeBulkImporter from './EmployeeBulkImporter';

const { TabPane } = Tabs;

const Settings = ({ match, history}) => {
  const { user } = useSelector((state) => state.login);

  const TabProps = {
    onTabClick: (key, e) => {
      console.log('onTabClick ///', key);
    },
    onEdit: (key, action) => {
      console.log('onEdit ///', key, action);
    },
  };

  return (
    <Layout title="Settings">
      <Tabs
        defaultActiveKey={
          typeof match.params !== 'undefined' &&
          typeof match.params.tab !== 'undefined'
            ? match.params.tab
            : 'employee-bulk-insert'
        }
        type="editable-card"
        size="medium"
        key={
          typeof match.params !== 'undefined' &&
          typeof match.params.tab !== 'undefined'
            ? match.params.tab
            : 'employee-bulk-insert'
        }
        className="settingsTab"
        hideAdd
        onTabClick={TabProps.onTabClick}
        onEdit={TabProps.onEdit}
        onChange={(key) => {
          history.push(`/settings/${key}`);
        }}
      >
        {user && user.ability.toImportEmployee && (
          <TabPane
            tab={<span>Bulk Add Employee</span>}
            key="employee-bulk-insert"
            closable={false}
          >
            <ErrorBoundary>
              <EmployeeBulkImporter />
            </ErrorBoundary>
          </TabPane>
        )}
        <TabPane
          tab={<span>Options</span>}
          key="manage-options"
          closable={false}
        >
          <Card style={{ minHeight: '200px', borderTop: '0' }}>
            <Tabs
              defaultActiveKey="1"
              type="editable-card2"
              size="medium"
              key="1"
              className="optionsTab"
              hideAdd
              onTabClick={TabProps.onTabClick}
              onEdit={TabProps.onEdit}
              tabPosition="left"
            >
              {user && user.ability.toManageDesignations && (
                <TabPane
                  tab={<span>Designations</span>}
                  key="manage-designations"
                  closable={false}
                >
                  <ErrorBoundary>
                    <CategoryManager catType="DESIGNATION" />
                  </ErrorBoundary>
                </TabPane>
              )}
              {user && user.ability.toManagePortfolios && (
                <TabPane
                  tab={<span>Portfolios</span>}
                  key="manage-portfolios"
                  closable={false}
                >
                  <ErrorBoundary>
                    <CategoryManager catType="PORTFOLIO" />
                  </ErrorBoundary>
                </TabPane>
              )}
              {user && user.ability.toManageRegions && (
                <TabPane
                  tab={<span>Regions</span>}
                  key="manage-regions"
                  closable={false}
                >
                  <ErrorBoundary>
                    <CategoryManager catType="REGION" />
                  </ErrorBoundary>
                </TabPane>
              )}
              {user && user.ability.toManageLocations && (
                <TabPane
                  tab={<span>Locations</span>}
                  key="manage-locations"
                  closable={false}
                >
                  <ErrorBoundary>
                    <CategoryManager
                      catType="LOCATION"
                      havingReference={true}
                      reference={{
                        dataIndex: ['region', 'name'],
                        key: 'region',
                        title: 'Region',
                        type: 'REGION',
                      }}
                    />
                  </ErrorBoundary>
                </TabPane>
              )}
              {user && user.ability.toManageLeaveTypes && (
                <TabPane
                  tab={<span>Leave Types</span>}
                  key="manage-leave-types"
                  closable={false}
                >
                  <ErrorBoundary>
                    <CategoryManager catType="LEAVE_TYPE" />
                  </ErrorBoundary>
                </TabPane>
              )}
              {user && user.ability.toManageConveyanceTypes && (
                <TabPane
                  tab={<span>Conveyance Types</span>}
                  key="manage-conveyance-types"
                  closable={false}
                >
                  <ErrorBoundary>
                    <CategoryManager catType="CONVEYANCE_TYPE" />
                  </ErrorBoundary>
                </TabPane>
              )}
              {user && user.ability.toManageAllowanceTypes && (
                <TabPane
                  tab={<span>Allowance Types</span>}
                  key="manage-allowance-types"
                  closable={false}
                >
                  <ErrorBoundary>
                    <CategoryManager catType="ALLOWANCE_TYPE" />
                  </ErrorBoundary>
                </TabPane>
              )}
              {user && user.ability.toManageDeductionTypes && (
                <TabPane
                  tab={<span>Deduction Types</span>}
                  key="manage-deduction-types"
                  closable={false}
                >
                  <ErrorBoundary>
                    <CategoryManager catType="DEDUCTION_TYPE" />
                  </ErrorBoundary>
                </TabPane>
              )}
              {user && user.ability.toManageProductTypes && (
                <TabPane
                  tab={<span>Product Types</span>}
                  key="manage-product-types"
                  closable={false}
                >
                  <ErrorBoundary>
                    <CategoryManager catType="PRODUCT_TYPE" />
                  </ErrorBoundary>
                </TabPane>
              )}
              {user && user.ability.toManageStages && (
                <TabPane
                  tab={<span>Stages</span>}
                  key="manage-stages"
                  closable={false}
                >
                  <ErrorBoundary>
                    <CategoryManager catType="STAGE" />
                  </ErrorBoundary>
                </TabPane>
              )}
            </Tabs>
          </Card>
        </TabPane>
        {/* <TabPane
          tab={<span>Role Permissions</span>}
          key="role-permissions"
          closable={false}
        >
          <ErrorBoundary>
            <RolePermissions />
          </ErrorBoundary>
        </TabPane> */}
      </Tabs>
    </Layout>
  );
};

export default Settings;
